import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../services/supabaseClient';
import { deleteObra, deleteLancamentoRecords } from '../services/api';
import { Lancamento } from '../services/types';

export const useObraActions = (
    obraId: string | undefined,
    obraNome: string | undefined,
    refetchDetails: () => void,
    setSnackbarMessage: (msg: string) => void,
    setIsDeleteModalOpen: (isOpen: boolean) => void,
    setRefreshLancamentosTrigger: React.Dispatch<React.SetStateAction<number>>
) => {
    const navigate = useNavigate();
    const [isDeleting, setIsDeleting] = useState(false);
    const [deleteError, setDeleteError] = useState<string | null>(null);

    const handleDeleteObra = async () => {
        if (!obraId) return;
        setIsDeleting(true);
        setDeleteError(null);
        try {
            await deleteObra(Number(obraId));
            setSnackbarMessage('Obra excluída com sucesso!');
            navigate('/obras');
        } catch (err) {
            setDeleteError('Erro ao excluir a obra. Tente novamente.');
            console.error(err);
        } finally {
            setIsDeleting(false);
            setIsDeleteModalOpen(false);
        }
    };

    const handleLancamentoDelete = async (lancamento: Lancamento) => {
        if (window.confirm('Tem certeza que deseja excluir este lançamento e todos os seus itens e anexos?')) {
            try {
                const anexoPaths = lancamento.anexos?.map((anexo: any) => anexo.caminho_arquivo) || [];
                if (anexoPaths.length > 0) {
                    const { error: storageError } = await supabase.storage.from('anexos').remove(anexoPaths);
                    if (storageError) throw new Error(`Erro ao deletar anexos: ${storageError.message}`);
                }
                await deleteLancamentoRecords(lancamento.id);
                setRefreshLancamentosTrigger(prev => prev + 1);
                setSnackbarMessage('Lançamento excluído com sucesso!');
                refetchDetails(); // Update balance
            } catch (error: any) {
                console.error(error);
                alert(`Erro ao excluir lançamento: ${error.message}`);
            }
        }
    };

    return {
        isDeleting,
        deleteError,
        handleDeleteObra,
        handleLancamentoDelete
    };
};
